import { MetadataInfoDTO } from "../DTO/metadataInfoDTO";
import { MetadataField } from "./metadataField";
import { TransformationRule } from "./transformationRule";

export class MetadataInfo{
    public name!: string;
    public ruleId!: number;
    public fields!: MetadataField[];
    public transformationRules!: TransformationRule[];

    constructor(){
        this.fields=[];
    }

    public static mapFromDTO(param:MetadataInfoDTO):MetadataInfo{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MetadataInfo();
        try
        {
            obj.name = param.name;
            obj.ruleId = param.ruleId;
            if(param.fields) obj.fields = param.fields.map(mdf=>MetadataField.mapFromDTO(mdf));
            if(param.transformationRules) obj.transformationRules = param.transformationRules.map(tr=>TransformationRule.mapFromDTO(tr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MetadataInfo):MetadataInfoDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MetadataInfoDTO();
        try
        {
            dto.name = param.name;
            dto.ruleId = param.ruleId;
            if(param.fields) dto.fields = param.fields.map(mdf=>MetadataField.mapToDTO(mdf));
            if(param.transformationRules) dto.transformationRules = param.transformationRules.map(tr=>TransformationRule.mapToDTO(tr));
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get clone(){
        let clone_mdi=new MetadataInfo();
        clone_mdi.name=this.name;
        clone_mdi.ruleId=this.ruleId;
        clone_mdi.fields=this.fields.map(f=>f.clone);
        clone_mdi.transformationRules=this.transformationRules.map(tr=>tr.clone);
        return clone_mdi;
    }
}